import type { ChatChannel } from '@/lib/api/common/interfaces/message.interface'
import { formatPhoneNumber } from '@/lib/form-state/util'

import { chatChannelMeta } from './chat-channel-icon'

interface ChatContactLabelProps {
    channel?: ChatChannel | null
    phoneNumber?: string | null
    className?: string
}

/**
 * Como identificar o contato de uma conversa na lista e no cabeçalho: no WhatsApp,
 * o telefone; no Instagram, no Messenger e no Dex (DEX_TALK), o canal — ali não há
 * telefone até o contato informar um.
 */
export default function ChatContactLabel({ channel, phoneNumber, className = '' }: ChatContactLabelProps) {
    if (channel && channel !== 'WHATSAPP') {
        const meta = chatChannelMeta(channel)
        const Icon = meta.icon
        return (
            <span className={`inline-flex items-center gap-1 ${className}`}>
                <Icon className={meta.text} />
                {meta.label}
                {phoneNumber ? ` · ${formatPhoneNumber(phoneNumber)}` : ''}
            </span>
        )
    }
    return <span className={className}>{formatPhoneNumber(phoneNumber ?? '')}</span>
}
